<template>
  <div>
    <section class="con4">
      <div class="top">
        <div class="container inner">
          <p
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            Brand Story
          </p>
          <p
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            최상의 명상 리더십 교육을 기획하고 제안합니다.
          </p>
          <div
            class="slider-wrap"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <VueSlickCarousel v-bind="settings2">
              <div class="item">
                <div class="img-wrap">
                  <img src="@/assets/img/centerone/con4/slide1.png" alt="img" />
                </div>
                <div class="m-pc-text">
                  <p>교육 콘텐츠</p>
                  <p>
                    리더에게 특화된 명상의 이론과 기법,<br />
                    현업에서 적용하는 실천을 기획합니다.
                  </p>
                </div>
              </div>
              <div class="item">
                <div class="img-wrap">
                  <img src="@/assets/img/centerone/con4/slide2.png" alt="img" />
                </div>
                <div class="m-pc-text">
                  <p>커뮤니티</p>
                  <p>
                    멤버십 서비스를 통해 안정적이고<br />
                    지혜로운 리더들과 네트워크를 돕습니다.
                  </p>
                </div>
              </div>
              <div class="item">
                <div class="img-wrap">
                  <img src="@/assets/img/centerone/con4/slide3.png" alt="img" />
                </div>
                <div class="m-pc-text">
                  <p>콜라보레이션</p>
                  <p>
                    다양한 브랜드와 협업하여<br />
                    사적이고 섬세한 경험을 만듭니다.
                  </p>
                </div>
              </div>
            </VueSlickCarousel>
          </div>
          <ul
            class="pc-wrap"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <li>
              <div>
                <img src="@/assets/img/centerone/con4/img1.png" alt="img" />
                <div class="hover">
                  <p>교육 컨텐츠</p>
                  <p>
                    리더에게 특화된 명상의 이론과<br />기법, 현업에서
                    적용하는<br />실천을 기획합니다.
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <img src="@/assets/img/centerone/con4/img2.png" alt="img" />
                <div class="hover">
                  <p>커뮤니티</p>
                  <p>
                    멤버십 서비스를 통해<br />안정적이고 지혜로운 리더들과<br />네트워크를
                    돕습니다.
                  </p>
                </div>
              </div>
            </li>
            <li>
              <div>
                <img src="@/assets/img/centerone/con4/img3.png" alt="img" />
                <div class="hover">
                  <p>콜라보레이션</p>
                  <p>
                    다양한 브랜드와 협업하여<br />사적이고 섬세한 경험을
                    만듭니다.
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom">
        <div class="container inner">
          <div class="con-wrap container">
            <div class="left">
              <p>
                명상 전문가로 구성된<br />
                교육 콘텐츠 담당 팀이<br class="br-m" />
                직접 기획합니다.
              </p>
              <p>
                센터원은 리더십 교육에 특화된 명상을<br class="br-m" />
                큐레이팅하여<br class="br-pc" />
                전문 강사님들과 함께<br class="br-m" />
                솔루션을 제공합니다.
              </p>
            </div>
            <div class="right">
              <img src="@/assets/img/centerone/con4/text.png" alt="img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },

  data() {
    return {
      settings2: {
        infinite: true,
        autoplay: true,
        speed: 1000,
        autoplaySpeed: 4000,
        cssEase: "ease-out",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        swipe: true,
        swipeToSlide: false,
        pauseOnHover: false,
        variableWidth: true,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
section {
  display: block;
}

img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.br-pc {
  display: none;

  @media screen and (min-width: 1200px) {
    display: block;
  }
}

// con4
.con4 {
  padding-top: 70px;
  overflow: hidden;

  @media screen and (min-width: 1200px) {
    padding-top: 150px;
  }

  .top {
    padding: 0 18px;
    margin-bottom: 70px;

    @media screen and (min-width: 1200px) {
      padding: 0;
      margin-bottom: 200px;
    }

    .inner {
      > p {
        &:nth-of-type(1) {
          font-size: 20px;
          font-weight: 700;
          color: #998465;
          margin-bottom: 20px;

          @media screen and (min-width: 1200px) {
            font-size: 24px;
          }
        }

        &:nth-of-type(2) {
          font-size: 30px;
          font-weight: 700;
          color: #000;
          margin-bottom: 44px;

          @media screen and (min-width: 1200px) {
            font-size: 46px;
            margin-bottom: 90px;
          }
        }
      }

      .slider-wrap {
        @media screen and (min-width: 1200px) {
          display: none;
        }

        :deep(.slick-slider) {
          .slick-list {
            border-radius: 10px;
            width: 100dvw !important;

            .slick-track {
              display: flex;

              .slick-slide {
                margin: 0 10px;

                > div {
                  .item {
                    position: relative;
                    border-radius: 10px;
                    overflow: hidden;

                    .img-wrap {
                      border-radius: 10px;
                      margin-bottom: 20px;
                      overflow: hidden;

                      img {
                        max-width: 264px;
                        min-height: 150px;
                      }
                    }

                    .m-pc-text {
                      p {
                        &:nth-of-type(1) {
                          font-size: 18px;
                          font-weight: 700;
                          margin-bottom: 10px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      .pc-wrap {
        display: none;

        @media screen and (min-width: 1200px) {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 60px;
        }

        li {
          border-radius: 20px;
          overflow: hidden;

          > div {
            position: relative;

            &:hover .hover {
              display: block;
            }

            .hover {
              display: none;
              position: absolute;
              inset: 0;
              background-color: rgba($color: #f7f2ec, $alpha: 0.5);
              backdrop-filter: blur(5px);
              padding: 60px 38px;

              p {
                &:nth-of-type(1) {
                  font-size: 34px;
                  font-weight: 700;
                  margin-bottom: 20px;
                }

                &:nth-of-type(2) {
                  font-size: 24px;
                  font-weight: 500;
                }
              }
            }
          }
        }
      }
    }
  }

  .bottom {
    display: flex;
    justify-content: center;
    padding: 0 18px;

    @media screen and (min-width: 1200px) {
      padding: 0;
    }

    > .container {
      background: url(~@/assets/img/centerone/con4/bg-m.png) no-repeat center /
        cover;
      border-radius: 10px;

      @media screen and (min-width: 1200px) {
        max-width: 1730px;
        min-width: 1730px;
        background: url(~@/assets/img/centerone/con4/bg-pc.png) no-repeat center /
          cover;
        border-radius: 20px;
      }

      .con-wrap {
        display: flex;
        flex-direction: column;
        gap: 70px;
        padding: 70px 30px;
        overflow: hidden;

        @media screen and (min-width: 1200px) {
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          gap: 0;
          padding: 128px 0;
        }

        .left {
          p {
            &:nth-of-type(1) {
              font-size: 20px;
              font-weight: 700;
              color: #fff;
              margin-bottom: 20px;

              @media screen and (min-width: 1200px) {
                font-size: 30px;
              }
            }

            &:nth-of-type(2) {
              color: #9f9f9f;

              @media screen and (min-width: 1200px) {
                font-size: 20px;
              }
            }
          }
        }

        .right {
          max-width: 556px;
        }
      }
    }
  }
}
</style>
